<section class="scr-page scr-page--compact">
  <div class="scr-card">
    <tp-page-header class="tp-page-header--split" variant="toolbar" title="Prestadores" [subtitle]="visibleCount + ' prestadores'">
      <div class="scr-search">
        <mat-icon class="scr-search__icon" aria-hidden="true">search</mat-icon>
        <input
          type="text"
          class="form-control"
          placeholder="Buscar prestador"
          aria-label="Buscar prestador"
          (keyup)="applyFilter($event)"
        />
      </div>
      @if (usrSvc.hasPermission('add:contractor')) {
        <button
          mat-stroked-button
          class="scr-btn-secondary"
          type="button"
          (click)="openFilterModal()"
          >
          <mat-icon>filter_list</mat-icon>
          {{ filterZone ? 'Zona filtrada' : 'Filtrar por zona' }}
        </button>
      }
      <button mat-flat-button actions class="scr-btn-primary" (click)="addSupplier()" aria-label="Agregar prestador">
        <mat-icon>add</mat-icon>
        Nuevo prestador
      </button>
    </tp-page-header>
        <div class="table-container scr-table-scroll">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        (matSortChange)="announceSortChange($event)"
        >
        <ng-container matColumnDef="fullName">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by fullName"
            >
            <span class="truncate">Prestador</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="name-cell">
              <div class="avatarContent">
                <div
                  class="avatar"
                [style.background]="
                  'url(' + imageSvc.getImage(element.url) + ')'
                "
                  >
                  <div
                    class="status-circle"
                  [style.background-color]="
                    imageSvc.getColorByStatus(element.stateId)
                  "
                  ></div>
                </div>
              </div>
              <div class="align-name">
                <span class="data">{{ element.fullName }}</span>
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="actionEmail">
          <th mat-header-cell *matHeaderCellDef class="align">
            <span class="truncate">Email</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="data">{{ element.email }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="dni">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by dni"
            >
            <span class="truncate">DNI</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="data">{{ element.dni }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="phone1">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by phone1"
            >
            <span class="truncate">Teléfono</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="data">{{ formatPhone(element.phones[0]) }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="score">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by score"
            >
            <span class="truncate">Score</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="data">{{ element.score }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="actionActivateDeactivate">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            <span class="truncate">Estado</span>
          </th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <button
              type="button"
              class="cursor-pointer scr-status"
              [ngClass]="element.isActive ? 'scr-status--success' : 'scr-status--neutral'"
              [attr.aria-label]="element.isActive ? 'Activo. Desactivar prestador' : 'Inactivo. Activar prestador'"
              (click)="activateDeactivate(element); $event.stopPropagation()"
              >
              {{ element.isActive ? "Activo" : "Inactivo" }}
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="actionMenu">
          <th mat-header-cell *matHeaderCellDef>
            <span class="truncate"> </span>
          </th>
          <td mat-cell *matCellDef="let element">
            <app-icon-menu-button [menu]="menu" label="Más opciones"></app-icon-menu-button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="associateSeller(element)">
                Asociar a vendedor
              </button>
              <button mat-menu-item (click)="goSupplierSkills(element)">
                Ver aptitudes
              </button>
              <button mat-menu-item (click)="goSupplierHours(element)">
                Ver horarios
              </button>
              <button mat-menu-item (click)="goSupplierVehicle(element)">
                Ver vehículos
              </button>
              <button mat-menu-item (click)="goSupplierAssistant(element)">
                Ver colaboradores
              </button>
              <button mat-menu-item (click)="goWorkingAreas(element)">
                Ver zona de acción
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="onRowClick(row)"
          (keydown)="onRowKeydown($event, row)"
          tabindex="0"
        ></tr>
      </table>
      @if (loaded && dataSource.filteredData.length === 0) {
        <tp-empty-state
          [icon]="dataSource.filter ? 'search_off' : 'engineering'"
          [title]="dataSource.filter ? 'Sin resultados' : (filterZone ? 'No hay prestadores en esta zona' : 'Todavía no hay prestadores')"
          [message]="dataSource.filter ? 'No hay prestadores que coincidan con la búsqueda.' : 'Cuando se registre un prestador lo vas a ver acá.'"
        ></tp-empty-state>
      }
    </div>
    <div class="scr-footer">
      <span class="scr-count">{{ visibleCount }} resultados</span>
      <mat-paginator
        [pageSizeOptions]="[10, 25, 100]"
        aria-label="Página del listado de prestadores"
      ></mat-paginator>
    </div>
  </div>

    <!-- Modal para filtro por zona de acción de prestador -->
    <div
      class="filter-modal-container d-flex align-items-center justify-content-center w-100"
      [ngClass]="{ expanded: showFilterModal }"
      >
      @if (showFilterModal) {
        <div class="modal-container w-100">
          <app-supplier-zone-filter
            [filterZone]="filterZone"
            (setFilteredZone)="setFilteredZone($event)"
            (closeModal)="backToList()"
          ></app-supplier-zone-filter>
        </div>
      }
    </div>
</section>
